import axios from "axios";

const bappebtiStore = {
    state: {
        dataHistories: [],
        totalDataHistories: "",
        isLoading: false,
        dataDetailHistory: {},
        dataListClient: [],
        tradeAccountData: [],

        totalTradeAccountData: null,
    },
    mutations: {
        setLoading(state, payload) {
            state.isLoading = payload;
        },
        setDataHistory(state, payload) {
            state.dataHistories = payload.body;
            state.totalDataHistories = payload.count;
        },
        setDetailHistory(state, payload) {
            state.dataDetailHistory = payload;
        },
        setClientList(state, payload) {
            state.dataListClient = payload;
        },
        setIsLoading(state, payload) {
            state.isLoading = payload;
        },
        setTradeAccountData(state, payload) {
            state.tradeAccountData = payload;
        },
        setTradeTotalData(state, payload) {
            state.totalTradeAccountData = payload;
        },
    },
    getters: {
        getDataTrade(state) {
            const filterData = state.tradeAccountData.filter(item=> item.trade_account.hin.startsWith('PC'))
            return filterData;
        },
    },
    actions: {
        async getHistoryData({ commit }, { activity, startDate, endDate, perPage, currentPage, type, owner }) {
            commit("setIsLoading", true);
            try {
                const offset = (currentPage - 1) * perPage;
                const response = await axios.get("/v2/clearing/admin/bappebti/get/list/metal", {
                    params: {
                        activity: activity,
                        startDate: startDate,
                        endDate: endDate,
                        limit: perPage,
                        offset: offset,
                        type: type,
                        owner: owner,
                    },
                });
                commit("setDataHistory", response.data.data);
                commit("setIsLoading", false);
            } catch {
                commit("setIsLoading", false);
            }
        },
        getDetailHistory: async ({ commit }, id) => {
            const response = await axios.get("/v2/clearing/admin/bappebti/get/detail/metal/" + id);
            commit("setDetailHistory", response.data.data);
        },
        getListClient: async ({ commit }) => {
            const response = await axios.get("/v2/clearing/admin/bappebti/get/list_depositor");
            commit("setClientList", response.data.data.body);
        },
        getTradeAccount({commit}, paramsData) {
            return new Promise((resolve, reject) =>{
                commit('setIsLoading', true)
                let bankCode = []
                let brokerCode = []
                if(paramsData.bank){
                    bankCode = paramsData.bank.map(data=> data.bank_code)
                }
                if(paramsData.broker){
                    brokerCode = paramsData.broker.map(data=> data.broker_code)
                }
    
                let offset = (paramsData.currentPage - 1) * paramsData.perPage
    
                axios.get('/v2/clearing/admin/get/trade_account', {
                    params: {
                        offset: offset,
                        limit: paramsData.perPage,
                        keyword: paramsData.keyword,
                        broker: brokerCode,
                        bank: bankCode,
                        sortby: paramsData.sortBy,
                        order: paramsData.order,
                        role: paramsData.role
                    }
                }).then(res=>{
                    const dataTrade = res.data.data.body
                    
                    commit('setTradeTotalData', res.data.data.count)
                    commit("setTradeAccountData", dataTrade);
                    commit('setIsLoading', false)
                    resolve(dataTrade)
                }).catch(error => {
                    commit('setIsLoading', false)
                    reject(error)
                })
            })
        },
        getDetailTradeAccount: async ({ commit }, account_id) => {
            commit('setIsLoading', true)
            try{
                const response = await axios.get( `/v2/clearing/admin/get/detail_gold_balances?account_id=${account_id}&hin=`);
                commit('setIsLoading', false)
                return response.data.data;
            } catch (error) {
                commit('setIsLoading', false)
                throw error;
            } finally {
                commit('setIsLoading', false)
            }
        },
    },
};

export default bappebtiStore;
